<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          Pattern
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Pattern</a>
          </li>
      </ul>
    </div>
      <b-row>
        <b-col lg="12" xl="12">
          <!-- 테스트 안내 메세지 -->
          <b-card v-if="is_test" class="text-center text-bold">
            <b-row>
              <b-col>
                Request inspection from {{ apply_request }} agents.
                <br>
                Once the full inspection is completed, the policy will be automatically activated.
                <br>
                If there's a problem with activating the policy, an email will be sent.
                <br>
                Please activate the email notification.
              </b-col>
            </b-row>
            <hr>
            <b-row v-if="apply_alive != apply_request" class="text-center">
              <b-col>
                <h5 class="text-danger">{{ apply_alive }} agents are online but other agents cannot test patterns offline. </h5>
                <h5 class="text-danger">To apply the pattern test, please switch to the online state and proceed with the test again. </h5>
                <h5 class="text-danger">If an agent does not apply a pattern test, it will be isolated immediately when using isolation mode. Unintentional service failures may occur in the future. </h5>
                <h5 class="text-danger"> If the pattern is not active, please contact q&a or partner. </h5>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-button block size="ml" class="text-white" variant="secondary" @click="list"> List </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-else>
            <b-row>
              <b-col>
                <strong>Pattern Detail</strong>
                <span class="float-right">{{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="is_use_true">Enable / Disable</label><br/>
                <c-switch v-model="model.is_alive"  :disabled="lock" color="success" label variant="pill"/><br>
              </b-col>
              <b-col>
                <label for="ph_type">Category</label>
                <b-form-select v-model="model.category" :options="codes.code_category" :disabled="lock"></b-form-select>
              </b-col>
              <b-col>
                <label for="ph_ext">Extension</label>
                <b-form-select v-model="model.ext" :options="codes.code_ext" :disabled="lock"></b-form-select>
              </b-col>
              <b-col>
                <label for="ph_type">Type</label>
                <b-form-select v-model="model.type" :options="codes.code_type" :disabled="lock"></b-form-select>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="ph_code">Code</label>
                <b-form-input md="5" type="text" id="ph_code" v-model="model.code" :disabled="lock"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="ph_content">Description</label>
                <b-form-textarea :rows="3" v-model="model.description" id="ph_content" :disabled="lock"></b-form-textarea>
              </b-col>
            </b-row>
            <hr>
            * For the purpose of checking the effect of the pattern, we attempt to check the entire scanning with one current pattern (recommended)
            <br>
            can disable a full inspection, but we don't recommend it.
            <br>
            We'll send you an e-mail when done checking
            <hr>

            <b-button class="btn-add" v-if="!lock" size="sm" variant="success" @click="modal_save = true"> Save </b-button>
            <b-button v-else="lock" size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
            <b-button v-if="!lock" size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
            <b-button v-else="lock" size="sm" variant="danger" @click="confirm = true"> Remove </b-button>
            <b-button v-if="lock" size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
          </b-card>
        </b-col>
      </b-row>
    <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
     Are you sure remove this pattern?
    </b-modal>
    <b-modal title="Test"  class="modal-danger" v-model="modal_save" hide-footer ok-variant="danger">
      <h6> <span class="text-primary">Test</span> : Apply after the pattern test.</h6>

      <h6> <span class="text-danger">Save</span> : Pattern test omitted and applied immediately</h6>

      <hr>
      <b-button block size="sm" variant="primary" @click="test"> Test </b-button>
      <b-button class="btn-add" block size="sm" variant="success" @click="save"> Save </b-button>
     </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
